import {Database} from '@tnc/shared';
import {SyntheticEvent} from 'react';

export type paginationObjT<
  T extends keyof Database['public']['Tables'],
  RowType extends object = Database['public']['Tables'][T]['Row'],
> = {
  currentPage: number;
  totalPages: number;
  currentData: RowType[];
  totalItemCount: number;
  limit: limitT;
  setLimit: (limit: limitT) => void;
  handlePrev: () => void;
  handleNext: () => void;
  goToPage: (page: number) => void;
};

export const VALID_LIMITS = [5, 10, 20, 50] as const;
export type limitT = (typeof VALID_LIMITS)[number];

export type ReactPaginateClickEventT = {
  event: SyntheticEvent<HTMLLinkElement>;
  index: null;
  isActive: boolean;
  isBreak: boolean;
  isNext: boolean;
  isPrevious: boolean;
  nextSelectedPage: number;
  selected: number;
};
